'use client';

import type { HTMLAttributes } from 'react';
import Link from 'next/link';
import { HiPhone } from 'react-icons/hi';

import { appointmentUrl, locationUrl } from 'src/services/route-utils';

type Props = {
    location: any;
    headingType?: 'h2' | 'h3';
} & HTMLAttributes<HTMLDivElement>;

export default function LocationCard({ location, headingType = 'h2', ...rest }: Props) {
    const Heading = headingType;

    return (
        <div className="flex flex-col bg-white p-4 hover:shadow-md md:flex-row md:py-8" {...rest}>
            <div className="flex-1">
                <Heading className="text-primary mb-3 text-2xl">{location.name}</Heading>
                <p className="my-1">{location.address}</p>
                {/* <p>
                    <HiPhone className="inline" />
                    <ContentRenderer content={location.phone} />
                </p> */}
            </div>
            <div className="md:w-2/5">
                <Link
                    className="bg-primary mt-2 block rounded-full p-2 text-center text-white"
                    href={appointmentUrl(location.code)}>
                    Programează-te online
                </Link>
                <Link
                    className="text-primary border-primary mt-2 block rounded-full border p-2 text-center"
                    href={locationUrl(location)}>
                    Vezi locația
                </Link>
            </div>
        </div>
    );
}
